import React, { createContext, useContext, useState, useCallback, useEffect } from "react";

const MockContext = createContext(null);

const STORAGE_KEY = "spartacus:mock-enabled";

export function MockProvider({ children }) {
  const [isMockEnabled, setIsMockEnabled] = useState(() => {
    return localStorage.getItem(STORAGE_KEY) === "true";
  });

  const toggleMock = useCallback(() => {
    setIsMockEnabled((prev) => {
      const next = !prev;
      localStorage.setItem(STORAGE_KEY, String(next));
      return next;
    });
  }, []);

  const enableMock = useCallback(() => {
    setIsMockEnabled(true);
    localStorage.setItem(STORAGE_KEY, "true");
  }, []);

  const disableMock = useCallback(() => {
    setIsMockEnabled(false);
    localStorage.setItem(STORAGE_KEY, "false");
  }, []);

  return (
    <MockContext.Provider value={{ isMockEnabled, toggleMock, enableMock, disableMock }}>
      {children}
    </MockContext.Provider>
  );
}

export function useMock() {
  const ctx = useContext(MockContext);
  if (!ctx) {
    throw new Error("useMock must be used within a MockProvider");
  }
  return ctx;
}
